var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-0" },
    [
      _c("loading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _vm.complete
        ? _c(
            "v-row",
            { attrs: { justify: "space-around mt-0 pt-0" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-0 pt-0",
                  attrs: {
                    xl: _vm.defaultColXl,
                    ld: _vm.defaultColLd,
                    md: _vm.defaultColMd,
                    sm: _vm.defaultColSm,
                    xs: _vm.defaultColXs
                  }
                },
                [
                  _c(
                    "v-sheet",
                    { attrs: { color: "blue lighten-5" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "space-around" } },
                        [
                          _c("v-col", { attrs: { cols: "11" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-bold subtitle-1 text-center"
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.complete_submit_comparing_data.messages.complete_alert_top"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-4" }, [
                              _c(
                                "div",
                                { staticClass: "subtitle-1 text-center" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.complete_submit_comparing_data.messages.complete_alert_detail.after_retry_process"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.initialRendering
        ? _c(
            "v-row",
            { attrs: { justify: "space-around mt-0 pt-0" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-0 pt-0",
                  attrs: {
                    xl: _vm.defaultColXl,
                    ld: _vm.defaultColLd,
                    md: _vm.defaultColMd,
                    sm: _vm.defaultColSm,
                    xs: _vm.defaultColXs
                  }
                },
                [
                  _c(
                    "v-sheet",
                    { attrs: { color: "blue lighten-5" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "space-around mt-0 pt-0" } },
                        [
                          _c("v-col", { attrs: { cols: "10" } }, [
                            _c("div", { staticClass: " text-center" }, [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold subtitle-1" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("しばらくお待ち下さい。"))
                                  )
                                ]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { justify: "space-around" } },
        [
          _c(
            "v-col",
            {
              attrs: {
                xl: _vm.defaultColXl,
                ld: _vm.defaultColLd,
                md: _vm.defaultColMd,
                sm: _vm.defaultColSm,
                xs: _vm.defaultColXs
              }
            },
            [
              !_vm.complete
                ? _c("label", { staticClass: "font-weight-bold title" }, [
                    _vm._v(
                      _vm._s(_vm.getCompanyName()) +
                        _vm._s(
                          _vm.$t(
                            "view.contract_form.confirm_identification.company_idetification_title"
                          )
                        )
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-divider")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.complete && _vm.showCompanyConfirm()
        ? _c(
            "v-row",
            { attrs: { justify: "space-around mt-0 pt-0" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-0 pt-0",
                  attrs: {
                    xl: _vm.defaultColXl,
                    ld: _vm.defaultColLd,
                    md: _vm.defaultColMd,
                    sm: _vm.defaultColSm,
                    xs: _vm.defaultColXs
                  }
                },
                [
                  _c(
                    "v-sheet",
                    { attrs: { color: "blue lighten-5" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "space-around mt-0 pt-0" } },
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xl: "9",
                                ld: "10",
                                md: "11",
                                sm: "11",
                                xs: "11"
                              }
                            },
                            _vm._l(
                              _vm.$t(
                                "view.contract_form.confirm_identification.messages.message_to_corporate_only_identification"
                              ),
                              function(message) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      "contract-form-check-email-messages-" +
                                      message
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(message) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-sheet",
                    { attrs: { color: "blue lighten-5" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "space-around mt-0 pt-0" } },
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xl: "9",
                                ld: "10",
                                md: "11",
                                sm: "11",
                                xs: "11"
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "caption font-weight-bold red--text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.messages.standard_plan_message"
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-panel", {
                    ref: "errorPanel",
                    attrs: { error: _vm.hasError }
                  }),
                  _vm._v(" "),
                  _c("validation-observer", {
                    ref: "inputObserver",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(InputObserver) {
                            return [
                              _c(
                                "v-row",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-0 pb-0",
                                      attrs: { cols: "12", sm: "12", md: "3" }
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass: "pt-3 pb-3 text-center",
                                          attrs: { color: "grey lighten-3" }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "view.contract_form.update.label.office_info.company_no"
                                                    )
                                                  ) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-4 pb-0",
                                      attrs: { cols: "12", sm: "12", md: "3" }
                                    },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          vid: "companyNumber",
                                          rules: "companyNumber|required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(checked) {
                                                return [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "mt-0 pt-0 pb-0",
                                                    attrs: {
                                                      maxlength: "13",
                                                      counter: "13",
                                                      disabled: false,
                                                      placeholder: _vm.$t(
                                                        "view.contract_form.update.placeholder.office_info.company_no"
                                                      ),
                                                      "persistent-hint": true,
                                                      autocomplete: "off"
                                                    },
                                                    model: {
                                                      value: _vm.companyNumber,
                                                      callback: function($$v) {
                                                        _vm.companyNumber = $$v
                                                      },
                                                      expression:
                                                        "companyNumber"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-1 pb-1",
                                      attrs: { cols: "12", sm: "12", md: "3" }
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass: "pt-3 pb-3 text-center",
                                          attrs: { color: "grey lighten-3" }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "view.contract_form.update.label.office_info.company_name"
                                                    )
                                                  ) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-1 pb-1",
                                      attrs: { cols: "12", sm: "12", md: "5" }
                                    },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          vid: "companyName",
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(checked) {
                                                return [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "mt-0 pt-0 pb-0",
                                                    attrs: {
                                                      disabled: false,
                                                      hint: _vm.$t(
                                                        "view.contract_form.update.hint.office_info.company_name"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "view.contract_form.update.placeholder.office_info.company_name"
                                                      ),
                                                      "persistent-hint": true,
                                                      id:
                                                        "office_info_company_name",
                                                      autocomplete: "off"
                                                    },
                                                    model: {
                                                      value: _vm.companyName,
                                                      callback: function($$v) {
                                                        _vm.companyName = $$v
                                                      },
                                                      expression: "companyName"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-1 pb-1",
                                      attrs: { cols: "12", sm: "12", md: "3" }
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass: "pt-3 pb-3 text-center",
                                          attrs: { color: "grey lighten-3" }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "view.contract_form.confirm_identification.messages.other_company_identification_form.label"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "caption font-weight-bold red--text"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "view.contract_form.confirm_identification.messages.other_company_identification_form.message"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "view.contract_form.confirm_identification.messages.other_company_identification_form.message2"
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-0 mt-0 pt-2 pb-0",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          vid: "companyCommonApprovalStatus",
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(checked) {
                                                return [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "mt-0 pt-0 pb-0",
                                                    attrs: {
                                                      disabled: true,
                                                      hint:
                                                        _vm.未申請 /
                                                        _vm.申請中 /
                                                        _vm.否認,
                                                      "persistent-hint": true,
                                                      id:
                                                        "office_info_company_name",
                                                      autocomplete: "off"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.companyCommonApprovalText,
                                                      callback: function($$v) {
                                                        _vm.companyCommonApprovalText = $$v
                                                      },
                                                      expression:
                                                        "companyCommonApprovalText"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-2 mt-0 pt-1 pb-1",
                                      attrs: { cols: "12", sm: "12", md: "3" }
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass: "pt-3 pb-3 text-center",
                                          attrs: { color: "grey lighten-3" }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.$t("法人住所")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mb-2 mt-0 pt-2 pb-0",
                                      attrs: { cols: "12", sm: "12", md: "6" }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "mb-0 mt-0 pt-2 pb-0",
                                              attrs: { cols: "4" }
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  vid: "zip1",
                                                  rules: "required|zip1"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(checked) {
                                                        return [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              disabled: false,
                                                              label: _vm.$t(
                                                                "view.contract_form.update.label.office_info.corporate_zip"
                                                              ),
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.office_info.corporate_zip_1"
                                                              ),
                                                              placeholder: _vm.$t(
                                                                "view.contract_form.update.placeholder.office_info.corporate_zip_1"
                                                              ),
                                                              "persistent-hint": true,
                                                              autocomplete:
                                                                "off"
                                                            },
                                                            model: {
                                                              value: _vm.zip1,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.zip1 = $$v
                                                              },
                                                              expression: "zip1"
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "mb-0 mt-0 pt-2 pb-0",
                                              attrs: { cols: "1" }
                                            },
                                            [_c("label", [_vm._v("-")])]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "mb-0 mt-0 pt-2 pb-0",
                                              attrs: { cols: "4" }
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  vid: "zip2",
                                                  rules: "required|zip2"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(checked) {
                                                        return [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              disabled: false,
                                                              label: _vm.$t(
                                                                "view.contract_form.update.label.office_info.corporate_zip_2"
                                                              ),
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.office_info.corporate_zip_2"
                                                              ),
                                                              placeholder: _vm.$t(
                                                                "view.contract_form.update.placeholder.office_info.corporate_zip_2"
                                                              ),
                                                              "persistent-hint": true,
                                                              autocomplete:
                                                                "off"
                                                            },
                                                            model: {
                                                              value: _vm.zip2,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.zip2 = $$v
                                                              },
                                                              expression: "zip2"
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-2" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "mb-0 mt-0 pt-2 pb-0",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  vid: "address1",
                                                  rules: "required"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(checked) {
                                                        return [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              disabled: false,
                                                              label: _vm.$t(
                                                                "view.contract_form.update.label.office_info.corporate_address_1"
                                                              ),
                                                              placeholder: _vm.$t(
                                                                "都道府県"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.address1,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.address1 = $$v
                                                              },
                                                              expression:
                                                                "address1"
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-2" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "mb-0 mt-0 pt-2 pb-0",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  vid: "address2",
                                                  rules: "required"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(checked) {
                                                        return [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              disabled: false,
                                                              label: _vm.$t(
                                                                "view.contract_form.update.label.office_info.corporate_address_2"
                                                              ),
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.office_info.corporate_address_2"
                                                              ),
                                                              placeholder: _vm.$t(
                                                                "view.contract_form.update.placeholder.office_info.corporate_address_2"
                                                              ),
                                                              "persistent-hint": true,
                                                              autocomplete:
                                                                "off"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.address2,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.address2 = $$v
                                                              },
                                                              expression:
                                                                "address2"
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-2" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "mb-0 mt-0 pt-2 pb-0",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  vid: "address3",
                                                  rules: "required"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(checked) {
                                                        return [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 pt-0 pb-0",
                                                            attrs: {
                                                              disabled: false,
                                                              label: _vm.$t(
                                                                "view.contract_form.update.label.office_info.corporate_address_3"
                                                              ),
                                                              hint: _vm.$t(
                                                                "view.contract_form.update.hint.office_info.corporate_address_3"
                                                              ),
                                                              placeholder: _vm.$t(
                                                                "view.contract_form.update.placeholder.office_info.corporate_address_3"
                                                              ),
                                                              "persistent-hint": true,
                                                              autocomplete:
                                                                "off"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.address3,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.address3 = $$v
                                                              },
                                                              expression:
                                                                "address3"
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                {
                                  staticClass: "pb-0 mb-0",
                                  attrs: { justify: "space-around" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "mb-0 mt-0 pt-0 pb-0 text-center",
                                      attrs: { cols: "12", sm: "12" }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.$t(
                                              "view.link.rehab_cloud_policy.href"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "view.link.rehab_cloud_policy.text"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                        ・\n                        "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.$t(
                                              "view.link.rehab_cloud_tablet_policy.href"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "view.link.rehab_cloud_tablet_policy.text"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                        ・\n                        "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.$t(
                                              "view.link.privacy.href"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("view.link.privacy.text")
                                            )
                                          )
                                        ]
                                      ),
                                      _c("br")
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { attrs: { justify: "space-around" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "mb-0 mt-0 pt-0 pb-1 text-center",
                                      attrs: { cols: "12", sm: "6", md: "6" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "login-button",
                                          attrs: {
                                            depressed: "",
                                            block: "",
                                            type: "submit",
                                            color: "#11479B",
                                            dark: true,
                                            readonly: true,
                                            active: false
                                          },
                                          on: { click: _vm.submitCorporateData }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "view.contract_form.confirm_identification.subimit_company_button_caption.submit_only_comparing_data"
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1492744346
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("simple-dialog", {
                attrs: {
                  "show-dialog": _vm.showAlertDialog,
                  "default-msg": _vm.alertDialogMessage,
                  "is-confirm": false,
                  "is-html": true
                },
                on: {
                  "ok-click": function($event) {
                    return _vm.dialogClose()
                  },
                  "cancel-click": function($event) {
                    return _vm.dialogClose()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6240ce5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6240ce5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/identification_form/IdentificationCompanyOnlyForm.vue
// module id = null
// module chunks = 